export default __webpack_public_path__ + "static/agriculture-51e5110dfac83a2d204b55cdeaeee61f.png";